import React, { createContext, useContext, useState, ReactNode } from 'react'
import { WordLength } from '../types/game'
import { trackModeSelected } from '../services/analyticsManager'

// Define the context type
interface GameContextType {
  isLoading: boolean
  initGame: (mode: string) => void
}

// Create context with a default value
const GameContext = createContext<GameContextType>({
  isLoading: true,
  initGame: () => {},
})

// Provider component
export const GameProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isLoading, setIsLoading] = useState(true)

  // Initialize the game with a specific mode
  const initGame = (mode: string) => {
    setIsLoading(true)

    try {
      // Convert mode to WordLength (4, 5, or 6)
      const modeNumber = parseInt(mode, 10) as WordLength

      // Track mode selection for analytics
      trackModeSelected(modeNumber)

      // Any other initialization logic here

      // Set loading to false immediately instead of using artificial delay
      setIsLoading(false)
    } catch (error) {
      console.error('Error initializing game:', error)
      setIsLoading(false)
    }
  }

  return (
    <GameContext.Provider value={{ isLoading, initGame }}>
      {children}
    </GameContext.Provider>
  )
}

// Custom hook for using the context
export const useGameContext = () => useContext(GameContext)
